import { Card, CardGroup } from "react-bootstrap";
import styled from "styled-components";
import { colors, types } from "../../../../libs";

export const PackagesCardGroup = styled(CardGroup)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(16rem, 100%), 1fr));
  gap: 1.25rem;
  align-items: stretch;
  width: 100%;
`;

export const PackageCard = styled(Card)`
  width: 100%;
  min-width: 0;
  min-height: 14rem;
  height: 100%;
  border: 1px solid ${colors.background.darkGreen} !important;
  border-radius: var(--bs-border-radius) !important;
  overflow: hidden;
`;

export const CardBody = styled(Card.Body)`
  min-width: 0;
  padding: clamp(1rem, 2vw, 1.5rem);
`;

export const AddPackageCard = styled(PackageCard)`
  border: 1px solid ${colors.background.darkGreen} !important;
  border-radius: var(--bs-border-radius) !important;
  background: ${colors.background.linearGradient};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${colors.text.mediumWhite};
`;

export const CardTitle = styled(Card.Title)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.75rem;
  min-width: 0;
  margin-bottom: 0.75rem;
  font-size: clamp(1.5rem, 1.3333rem + 0.8889vw, 2rem);

  & > :last-child {
    flex: 0 0 auto;
  }
`;

export const PackageName = styled.span`
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const PriceLabel = styled.h3`
  margin-bottom: 0.75rem;
  overflow-wrap: anywhere;

  &.price {
    font-size: clamp(1.5rem, 1.3333rem + 0.8889vw, 2rem);
    font-weight: 700;
    color: var(--color-primary);

    & span {
      font-size: clamp(1rem, 0.8333rem + 0.8889vw, 1.5rem);
      font-weight: 400;
      opacity: 0.7;
    }
  }
`;

export const FeaturesList = styled.ul`
  margin: 0.75rem 0 0;
  padding-left: 1.25rem;
`;

export const FeatureListItem = styled.li`
  list-style-type: initial;
  margin: 0.45rem 0;
  padding-left: 0.25rem;
  overflow-wrap: anywhere;
`;

export const AddIconWrapper = styled.button.attrs({
  type: "button",
  "aria-label": "Create a new package",
})`
  height: 50px;
  width: 50px;
  padding: 0;
  border: 0;
  background: ${colors.background.black};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;

  &:focus-visible {
    outline: 3px solid ${colors.text.mediumWhite};
    outline-offset: 3px;
  }
`;

export const AddIconText = styled.div`
  color: ${colors.text.mediumWhite};
  ${types.body.title};
`;
